import { useSelector } from 'react-redux';

import { RootState } from '@/redux/rootReducer';

const useLoyaltyAccess = (): boolean => {
  const hasLoyaltyAccess = useSelector((state: RootState) => state?.auth?.user?.loyalty_access);
  return hasLoyaltyAccess;
};

export default useLoyaltyAccess;
